import { FormsyRadioGroup, Radio } from '@thanx/uikit/radio'
import { buildTranslate } from 'locales'
import { PreferencesModalSetting as SelectionType } from 'models/Config'
import React from 'react'

const t = buildTranslate('cms.settings.preferences_modal_setting')

const OPTIONS = [
  SelectionType.NEVER,
  SelectionType.ALWAYS,
  SelectionType.FIRST_ORDER,
]

type BaseProps = {
  value: SelectionType | undefined
  recommended?: SelectionType
}

type Props = BaseProps &
  (
    | { name: 'appSelection'; translationScope: 'app_selection' }
    | { name: 'webSelection'; translationScope: 'web_selection' }
  )

const SelectionGroup: React.FC<Props> = ({
  name,
  translationScope,
  value,
  recommended,
}) => (
  <FormsyRadioGroup name={name} value={value}>
    {OPTIONS.flatMap((option, index) => [
      <Radio
        key={option}
        value={option}
        className={index > 0 ? 'mt-s' : undefined}
      >
        {t(`${translationScope}.${option}`)}
        {option === recommended && (
          <>
            {' '}
            <span className="grey-50">({t('recommended')})</span>
          </>
        )}
      </Radio>,
      value === option && (
        <p
          key={`${option}-explanation`}
          className="body-text-4 grey-70 ml-l mt-xxs"
        >
          {t(`${translationScope}.${option}_explanation`)}
        </p>
      ),
    ])}
  </FormsyRadioGroup>
)

export default SelectionGroup
